<div class="team-login-container">
  <div class="login-card">
    <!-- Logo/Header -->
    <div class="login-header">
      <h1>Befret Team Access</h1>
      <p class="subtitle">Environnement de développement réservé à l'équipe</p>
    </div>

    <!-- Error Message -->
    <div *ngIf="errorMessage" class="alert alert-danger" role="alert">
      {{ errorMessage }}
    </div>

    <!-- Google Login Button -->
    <button
      class="btn btn-google"
      (click)="loginWithGoogle()"
      [disabled]="loading">
      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
        <path fill="#4285F4" d="M16.51 8H8.98v3h4.3c-.18 1-.74 1.84-1.6 2.42v2.62h2.6c1.52-1.4 2.4-3.45 2.4-5.87 0-.57-.05-1.13-.15-1.67z"/>
        <path fill="#34A853" d="M8.98 17c2.16 0 3.97-.72 5.3-1.94l-2.6-2.02c-.71.48-1.62.76-2.7.76-2.08 0-3.84-1.4-4.47-3.29H1.85v2.09C3.2 15.02 5.9 17 8.98 17z"/>
        <path fill="#FBBC05" d="M4.5 10.51c-.16-.48-.25-.99-.25-1.51s.09-1.03.25-1.51V5.4H1.85C1.27 6.55.98 7.73.98 9s.29 2.45.87 3.6l2.65-2.09z"/>
        <path fill="#EA4335" d="M8.98 4.18c1.17 0 2.23.4 3.06 1.2l2.3-2.3C13.15 1.37 11.16.5 8.98.5c-3.08 0-5.78 1.98-7.13 4.4L4.5 7c.63-1.89 2.39-3.29 4.48-3.29z"/>
      </svg>
      <span *ngIf="!loading">Se connecter avec Google</span>
      <span *ngIf="loading">Connexion en cours...</span>
    </button>

    <!-- Divider -->
    <div class="divider">
      <span>OU</span>
    </div>

    <!-- Email/Password Login Form -->
    <form (ngSubmit)="loginWithEmail()">
      <div class="form-group">
        <label for="email">Email</label>
        <input
          type="email"
          class="form-control"
          id="email"
          [(ngModel)]="email"
          name="email"
          placeholder="votre-email@befret.be"
          [disabled]="loading"
          required>
      </div>

      <div class="form-group">
        <label for="password">Mot de passe</label>
        <input
          type="password"
          class="form-control"
          id="password"
          [(ngModel)]="password"
          name="password"
          placeholder="••••••••"
          [disabled]="loading"
          required>
      </div>

      <button
        type="submit"
        class="btn btn-primary btn-block"
        [disabled]="loading || !email || !password">
        <span *ngIf="!loading">Se connecter</span>
        <span *ngIf="loading">Connexion...</span>
      </button>
    </form>

    <!-- Footer Info -->
    <div class="login-footer">
      <p class="text-muted">
        Seuls les membres de l'équipe Befret peuvent accéder à cet environnement.
      </p>
    </div>
  </div>
</div>
